<template>
  <v-card flat>
    <v-row justify="space-between" align="end">
      <v-col cols="auto">
        <span class="text-h6 font-weight-bold">
          {{ $t("users_and_ordered_meals") }}
        </span>
      </v-col>
      <v-col cols="auto">
        <shift-picker v-model="selectedShift" :shifts="shifts" />
      </v-col>
    </v-row>
    <v-row>
      <template v-if="dayLoading">
        <v-col cols="12">
          <div class="text-center pa-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
            ></v-progress-circular>
            <div class="mt-2">{{ $t("loading") }}</div>
          </div>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" md="4" v-for="user in filterByShift" :key="user.key">
          <div
            class="pa-4 fill-height rounded-lg"
            style="border: 1px solid rgba(0, 0, 0, 0.12)"
          >
            <p class="text-center">
              <span class="grey--text">#{{ user.id }}</span>
              <span class="font-weight-bold">
                {{ toLatin(user.name) + " " + toLatin(user.lastname) }}
              </span>
              <span v-if="isRange" class="grey--text"> ({{ user.date }})</span>
            </p>
            <div v-if="user.orders.length">
              <p v-for="(item, index) in user.orders" :key="index">
                {{ item.quantity }}<span class="grey--text">x</span>
                {{ toLatin(item.name || "") }}
              </p>
            </div>
          </div>
        </v-col>
      </template>
    </v-row>
  </v-card>
</template>

<script>
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasFoodKorisniciByDay from "@/mixins/report/hasFoodKorisniciByDay";

export default {
  mixins: [hasPrinting, hasExcel, hasReportPrinting, hasFoodKorisniciByDay],
  data() {
    return {
      selectedShift: null,
    };
  },
  computed: {
    // Grupisano po korisniku (user_id), a za period i po danu i smeni
    users() {
      const byKey = new Map();
      this.dayRows.forEach((row) => {
        const key = [row.user_id, row.date, row.shift].join("|");
        if (!byKey.has(key)) {
          byKey.set(key, {
            key,
            id: row.user_id,
            name: row.name,
            lastname: row.lastname,
            date: row.date,
            shift: row.shift,
            orders: [],
          });
        }
        byKey.get(key).orders.push({
          quantity: row.quantity,
          name: row.meal_name,
          category_id: row.category_id,
        });
      });
      return [...byKey.values()];
    },
    filterByShift() {
      return this.users.filter((user) => user.shift === this.selectedShift);
    },
    isRange() {
      return this.reportDates.from !== this.reportDates.to;
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies
        .map((company) => this.toLatin(company?.name || ""))
        .join(", ");
    },
    shifts() {
      return [...new Set(this.dayRows.map((row) => row.shift))].sort((a, b) => a - b);
    },
    // Kolone grupa jela su po category_id
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("last_name"), value: "lastname" },
        ...this.dayCategoryList.map((category) => ({
          text: this.dayCategoryLabels[category.id],
          value: String(category.id),
        })),
      ];
    },
  },
  watch: {
    isPrinting() {
      if (this.isPrinting) {
        let appendHtml = `<div style='display: flex;flex-wrap: wrap;'>`;
        this.filterByShift.forEach((user) => {
          appendHtml += `<div style='flex: 0 0 50%;box-sizing: border-box;padding: 12px;border: 1px solid #ccc;'>
          <h3 style="text-align:center;margin-top: 0"><small style="color: #999">#${
            user.id
          }</small> ${this.toLatin(user.name)} ${this.toLatin(user.lastname)}</h3>`;
          user.orders.forEach((order) => {
            if (order.name) {
              appendHtml += `<p>${order.quantity}x ${this.toLatin(order.name)}</p>`;
            }
          });
          appendHtml += `</div>`;
        });
        appendHtml += `</div>`;
        this.printDocument({
          title: this.$t("users_and_ordered_meals"),
          afterTableHtml: appendHtml,
          subtitle: this.subtitle,
          beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompanies}</h4>`,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        const orders = this.filterByShift.map((user) => {
          const row = { name: user.name, lastname: user.lastname };
          this.dayCategoryList.forEach((category) => {
            row[category.id] = user.orders
              .filter((order) => order.category_id === category.id)
              .map((order) => order.quantity + "x " + this.toLatin(order.name || ""))
              .join(", ");
          });
          return row;
        });
        this.downloadExcel({
          fileName: this.$t("users_and_ordered_meals") + ".xlsx",
          sheets: [
            {
              name: this.$t("user_overview"),
              headers: this.headers,
              items: orders,
              title: this.$t("users_and_ordered_meals"),
              subtitle: this.subtitle,
              beforeTableHtml: `<h4 style="text-align: center">${
                this.selectedCompanies || ""
              }</h4>`,
            },
          ],
        });
      }
    },
    shifts: {
      handler() {
        if (this.shifts.length) {
          this.selectedShift = this.shifts[0];
        } else {
          this.selectedShift = null;
        }
      },
      immediate: true,
    },
  },
};
</script>
